(
  function() {
  const script = document.getElementById('atome-intro-js') || document.currentScript;
  const { country = 'sg', lang = 'en' } = queryParams(script && script.src);
  const isTest = /wc-test|localhost|\.apaylater\.net/.test(location.href);
  const baseUrl = isTest ? 'https://gateway.apaylater.net' : 'https://gateway.apaylater.com';
  const introBaseUrl = baseUrl + '/plugins/intro';
  const imgSrcs = {
    close: introBaseUrl + '/close.png',
    logo: baseUrl + '/plugins/common/assets/svg/logo.svg',
    zero_interest: introBaseUrl + '/ic-interest.svg',
    split_into_3: introBaseUrl + '/ic-installments.svg',
    hundreds_merchants: introBaseUrl + '/ic-merchants.svg',
    arrow_back: introBaseUrl + '/arrow-back.svg',
  };

  const head = document.getElementsByTagName('head')[0];
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.type = 'text/css';
  link.href = introBaseUrl + '/index.css';
  link.media = 'all';
  head.appendChild(link);

  if (/amazingraze.com/.test(location.hostname) && /\/checkout/.test(location.pathname)) {
    const thirdTcLink = document.createElement('script');
    thirdTcLink.async = true;
    thirdTcLink.src = baseUrl + '/plugins/terms-conditions/amazin-graze.js';
    head.appendChild(thirdTcLink);
  }

  String.prototype.AtomeFormat = function (tokens) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    let formatted = this;
    for (const key in tokens) {
      if (tokens.hasOwnProperty(key)) {
        formatted = formatted.replace(RegExp('{' + key + '}', 'g'), tokens[key]);
      }
    }
    return formatted;
  };

  let currentTCLink = 'https://www.atome.sg/en-sg/terms-of-service';
  const countryConfig = {
    sg: {
      offical_site: 'https://www.atome.sg',
      t_c_link: 'https://www.atome.sg/en-sg/terms-of-service',
    },
    hk: {
      offical_site: 'https://www.atome.hk/{lang}-hk',
      t_c_link: 'https://www.atome.hk/{lang}-hk/terms-of-service',
    },
    my: {
      offical_site: 'https://www.atome.my',
      t_c_link: 'https://www.atome.my/en-my/terms-of-service',
    },
    id: {
      offical_site: 'https://www.atome.id',
      t_c_link: 'https://www.atome.id/id-id/terms-of-service',
    },
    th: {
      offical_site: 'https://www.atometh.com',
      t_c_link: 'https://www.atometh.com/{lang}-th/terms-of-service',
    },
    jp: {
      offical_site: 'https://www.atome.co.jp/',
      t_c_link: 'https://www.atome.co.jp/terms-of-service',
    },
    ph: {
      offical_site: 'https://www.atome.ph/',
      t_c_link: 'https://www.atome.ph/terms-of-service',
    }
  };

  currentTCLink = typeof countryConfig[country] != 'undefined' ? countryConfig[country]['t_c_link'] : currentTCLink;
  currentTCLink = currentTCLink.AtomeFormat({
    lang: lang
  });

  let currentOfficalSite =
    typeof countryConfig[country] != 'undefined' ? countryConfig[country]['offical_site'] : 'https://www.atome.sg';

  currentOfficalSite = currentOfficalSite.AtomeFormat({
    lang: lang
  });

  if (document.body) {
    appendTemplateOnce();
  } else {
    if (window.attachEvent) {
      window.attachEvent('onload', appendTemplateOnce);
    } else {
      window.addEventListener('load', appendTemplateOnce, false);
    }
  }

  document.addEventListener('click', function(e) {
    const ele = e.target;

    if (ele.className && typeof ele.className === 'string' && ele.className.includes('atome-icon')) {
      e.preventDefault();
      e.stopPropagation();
      if (!document.querySelector('.atome-mask')) {
        appendTemplateOnce();
      }
      const atomeMask = document.querySelector('.atome-mask');
      atomeMask.querySelectorAll('img').forEach(_ele => {
        if (_ele.getAttribute('src')) {
          return;
        }

        const srcId = _ele.getAttribute('data-atome-src');
        if (srcId && imgSrcs[srcId]) {
          _ele.setAttribute('src', imgSrcs[srcId]);
        }
      });
      atomeMask.querySelector('#atome-introduction-container').style.display = '';
      atomeMask.querySelector('#atome-terms-conditions-container').style.display = 'none';
      atomeMask.style.display = '';
    } else if (ele.className && typeof ele.className === 'string' && ele.className.includes('atome-mask')) {
      document.querySelector('.atome-mask').style.display = 'none';
    }
  });

  if (window.attachEvent) {
    window.attachEvent('onload', addTCListener);
  } else {
    window.addEventListener('load', addTCListener, false);
  }

  function addTCListener() {
    const $atomeTermsAndConditionsLink = document.querySelector('.atome-terms-conditions');
    if ($atomeTermsAndConditionsLink) {
      $atomeTermsAndConditionsLink.addEventListener('click', function(e){
        e.preventDefault();
        showTCInfo();
      });
    } else {
      document.addEventListener('click', function(e) {
        const ele = e.target;
        if ((ele.className && typeof ele.className === 'string' && ele.className.includes('atome-terms-conditions')) || (ele.parentElement.className && typeof ele.parentElement.className === 'string' && ele.parentElement.className.includes('atome-terms-conditions'))) {
          e.preventDefault();
          e.stopPropagation();
          showTCInfo();
        } else if (ele.className && typeof ele.className === 'string' && ele.className.includes('atome-mask')) {
          document.querySelector('.atome-mask').style.display = 'none';
        }
      });
     }
  }

  addTCListener();

  function showTCInfo() {
    if (!document.querySelector('.atome-mask #atome-introduction-container')) {
      appendTemplateOnce();
    }

    const atomeMask = document.querySelector('.atome-mask');
    atomeMask.querySelector('#atome-introduction-container').style.display = 'none';
    atomeMask.querySelector('#atome-terms-conditions-container').style.display = '';
    atomeMask.querySelector('#atome-terms-conditions-container .back').style.display = 'none';
    const tcIframe = atomeMask.querySelector('#atome-terms-conditions-container iframe');
    if(tcIframe){
      tcIframe.src = currentTCLink;
    }
    atomeMask.querySelectorAll('#atome-terms-conditions-container img').forEach(_ele => {
      if (_ele.getAttribute('src')) {
        return;
      }

      const srcId = _ele.getAttribute('data-atome-src');
      if (srcId && imgSrcs[srcId]) {
        _ele.setAttribute('src', imgSrcs[srcId]);
      }
    });

    atomeMask.style.display = '';
  }


  function appendTemplateOnce() {
    const template = `
        <div class="atome-main">
          <div class="sub right" id="atome-introduction-container">
            <img onclick="atomeWidget.hideAtome()" class="close" data-atome-src="close" />
            <a href="${currentOfficalSite}" target="_blank">
              <img class="atome-intro-logo" data-atome-src="logo" />
            </a>
            <div class="atome-love-it">${t('love-it')}</div>
            <div class="atome-no-wait">${t('why-wait')}</div>
            <div class="desc-container">
              <div class="desc">
                <img data-atome-src="zero_interest" />
                <div class="text"><b>${t('o-interest')}</b><br />${t('100-tran')}</div>
              </div>
              <div class="desc">
                <img data-atome-src="split_into_3" />
                <div class="text"><b>${t('split-into-3')}</b><br />${t('free-expe')}</div>
              </div>
              <div class="desc">
                <img data-atome-src="hundreds_merchants" />
                <div class="text"><b>${t('hundreds-merchants')}</b><br />${t('vast-variety')}</div>
              </div>
            </div>
            <a href="" class="terms-conditions">${t('terms-conditions')} ></a>
            <a href="${currentOfficalSite}/how-it-works" class="how-it-works" target="_blank">${t('how-works')}</a>
          </div>
          <div class="sub right" id="atome-terms-conditions-container" style="display:none;">
            <img onclick="atomeWidget.hideAtome()" class="close" data-atome-src="close" />
            <div class="back">
              <img class="arrow-back" data-atome-src="arrow_back" /> 
              <span>${t('back')}</span>
            </div>
            <div class="atome-iframe-wrapper">
              <iframe src=""></iframe>
            </div>
          </div>
        </div>`;

    let atomeMask = document.querySelector('.atome-mask');
    if (!atomeMask) {
      atomeMask = document.createElement('div');
      atomeMask.setAttribute('class', 'atome-mask');
      atomeMask.style.display = 'none';
      atomeMask = document.body.insertBefore(atomeMask, document.body.firstChild);
      atomeMask.innerHTML = template;
    }

    document.querySelector('.atome-main #atome-introduction-container .terms-conditions').addEventListener('click', function(e){
      e.preventDefault();
      document.getElementById('atome-introduction-container').style.display = 'none';
      const tcIframe = document.querySelector('#atome-terms-conditions-container iframe');
      if(tcIframe){
        tcIframe.src = currentTCLink;
      }
      document.getElementById('atome-terms-conditions-container').style.display = '';
    });

    document.querySelector('.atome-main #atome-terms-conditions-container .back').addEventListener('click', function(e){
      e.preventDefault();
      document.getElementById('atome-introduction-container').style.display = '';
      document.getElementById('atome-terms-conditions-container').style.display = 'none';
    });
  }

  const addToAtomeWidget = {
    hideAtome,
    gotoWeb,
  };

  if (window.atomeWidget) {
    atomeWidget = { ...atomeWidget, ...addToAtomeWidget };
  } else {
    atomeWidget = addToAtomeWidget;
  }

  function hideAtome() {
    document.querySelector('.atome-mask').style.display = 'none';
  }

  function gotoWeb() {
    window.open('https://www.atome.' + country);
  }

  function queryParams(str) {
    if (!(str && str.includes('?'))) {
      return { country: 'sg', lang: 'en' };
    }
    const paramsArr = str.split('?')[1].split('&');
    return paramsArr.reduce((acc, item) => {
      const [k, v] = item.split('=');
      acc[k] = k == 'lang' ? v.substring(0, 2) : v;
      return acc;
    }, {});
  }

  function t(key) {
    let i18nRes = {
      'love-it': 'Time to own it',
      'why-wait': 'Why wait? Shop today, 0% interest over 3 payments.',
      'o-interest': '0% interest',
      '100-tran': '100% transparent',
      'split-into-3': 'Split bill into 3 payments',
      'free-expe': 'Hassle-free experience',
      'hundreds-merchants': 'Hundreds of merchants',
      'vast-variety': 'Vast variety',
      'how-works': 'How it works',
      'terms-conditions': 'Terms & Conditions',
      'back': 'Back'
    };

    if (lang === 'zh') {
      if (country === 'tw') {
        i18nRes = {
          'love-it': 'å³åˆ»æ“æœ‰',
          'why-wait': 'ä½•é ˆç­‰å¾…?äº«å—ä»Šå¤©ç«‹å³æ“æœ‰ï¼Œ0åˆ©çŽ‡3æœŸè¼•é¬†ä»˜',
          'o-interest': '0%åˆ©çŽ‡',
          '100-tran': '100%é€æ˜Ž',
          'split-into-3': 'è‡ªå‹•åˆ†ä¸‰æœŸ',
          'free-expe': 'çµ•ä½³é«”é©—',
          'hundreds-merchants': '100+ å•†åº—',
          'vast-variety': 'æ‡‰æœ‰ç›¡æœ‰',
          'how-works': 'å¦‚ä½•é‹ä½œ',
          'terms-conditions': 'æ¢æ¬¾åŠç´°å‰‡',
          back: 'è¿”å›ž',
        };
      } else {
        i18nRes = {
          'love-it': 'ä¸€æ„›å³äº«ï¼Œéˆæ´»ä»˜æ¬¾ã€‚',
          'why-wait': 'åˆ¥ç­‰äº†ï¼ç”¨Atomeè³¼ç‰©ï¼Œå³äº«å…æ¯ä¸‰æœŸä»˜æ¬¾ã€‚',
          'o-interest': '0%åˆ©æ¯',
          '100-tran': '100%é€æ˜Žåº¦',
          'split-into-3': 'åˆ†ä¸‰æœŸä»˜æ¬¾',
          'free-expe': 'è¼•é¬†ç„¡æ†‚',
          'hundreds-merchants': '100+ å•†åº—',
          'vast-variety': 'æ‡‰æœ‰ç›¡æœ‰',
          'how-works': 'å¦‚ä½•é‹ä½œ',
          'terms-conditions': 'æ¢æ¬¾åŠç´°å‰‡',
          'back': 'è¿”å›ž',
        };
      }
    } else if (lang === 'id') {
      i18nRes = {
        'love-it': 'Cari. Belanja. Bayar nanti.',
        'why-wait': 'Belanja sekarang dengan cicilan 0%, 3x pembayaran.',
        'o-interest': 'Bunga 0%',
        '100-tran': '100% Transparan',
        'split-into-3': 'Bagi Tagihan dalam 3 Cicilan',
        'free-expe': 'Pengalaman mudah dalam bertransaksi',
        'hundreds-merchants': 'Ratusan Merchant',
        'vast-variety': 'Banyak pilihan untuk berbelanja',
        'how-works': 'Lihat Selengkapnya?',
        'terms-conditions': 'Terms & Conditions',
        'back': 'Back'
      };
    } else if (lang === 'th') {
      i18nRes = {
        'love-it': 'à¹„à¸”à¹‰à¹€à¸§à¸¥à¸²à¹€à¸›à¹‡à¸™à¹€à¸ˆà¹‰à¸²à¸‚à¸­à¸‡à¹à¸¥à¹‰à¸§',
        'why-wait': 'à¸­à¸¢à¹ˆà¸²à¸¥à¸±à¸‡à¹€à¸¥ à¸‹à¸·à¹‰à¸­à¸§à¸±à¸™à¸™à¸µà¹‰à¸‡à¹ˆà¸²à¸¢à¹†, à¸šà¸´à¸¥à¹à¸šà¹ˆà¸‡à¹€à¸›à¹‡à¸™ 3 à¸‡à¸§à¸”à¸”à¸­à¸à¹€à¸šà¸µà¹‰à¸¢ 0%',
        'o-interest': 'à¸”à¸­à¸à¹€à¸šà¸µà¹‰à¸¢ 0%',
        '100-tran': 'à¹‚à¸›à¸£à¹ˆà¸‡à¹ƒà¸ª 100%',
        'split-into-3': 'à¸šà¸´à¸¥à¸ˆà¸°à¸–à¸¹à¸à¹à¸šà¹ˆà¸‡à¹€à¸›à¹‡à¸™ 3 à¸‡à¸§à¸”',
        'free-expe': 'à¹ƒà¸Šà¹‰à¸‡à¸²à¸™à¸‡à¹ˆà¸²à¸¢',
        'hundreds-merchants': 'à¸¡à¸µà¸£à¹‰à¸²à¸™à¸„à¹‰à¸²à¸¡à¸²à¸à¸¡à¸²à¸¢',
        'vast-variety': 'à¸¡à¸µà¸«à¸¥à¸²à¸à¸«à¸¥à¸²à¸¢à¹à¸šà¸£à¸™à¸”à¹Œ',
        'how-works': 'à¸§à¸´à¸˜à¸µà¸à¸²à¸£à¹ƒà¸Šà¹‰à¸‡à¸²à¸™',
        'terms-conditions': 'à¹€à¸‡à¸·à¹ˆà¸­à¸™à¹„à¸‚à¹à¸¥à¸°à¸‚à¹‰à¸­à¸•à¸à¸¥à¸‡',
        'back': 'à¸¢à¹‰à¸­à¸™à¸à¸¥à¸±à¸š',
      };
    } else if (lang === 'ja') {
      i18nRes = {
        'love-it': 'ä»ŠãŒè²·ã„æ™‚',
        'why-wait': 'å¾…ãŸãšã«ä»Šæ—¥ãŠè²·ã„ç‰©ã€æ‰‹æ•°æ–™ç„¡æ–™ã§3å›žæ‰•ã„',
        'o-interest': 'æ‰‹æ•°æ–™ã¯ç„¡æ–™',
        '100-tran': '100%ã®é€æ˜Žæ€§',
        'split-into-3': 'æ”¯æ‰•ã„ã‚’3å›žã®åˆ†å‰²æ‰•ã„ã«',
        'free-expe': 'æ‰‹é–“ã„ã‚‰ãšãªè²·ã„ç‰©ä½“é¨“',
        'hundreds-merchants': 'é¸ã¹ã‚‹åŠ ç›Ÿåº—ã¯å¤šæ•°',
        'vast-variety': 'å¤šç¨®å¤šæ§˜ãªã‚·ãƒ§ãƒƒãƒ”ãƒ³ã‚°',
        'how-works': 'ä½¿ã„æ–¹',
        'terms-conditions': 'åˆ©ç”¨è¦ç´„',
        'back': 'æˆ»ã‚‹',
      };
    }

    if(/ph.sunniesstudios.com/.test(location.hostname) && key === 'how-works') {
      return (i18nRes[key] ?? '').toUpperCase();
    }

    return i18nRes[key] || '';
  }
})();